import { makeStyles } from '@mui/styles';
const emissionsStyles = makeStyles(() => ({
    container: {},
    label: {
        display: 'inline-block',
    },
}), { name: 'Common_Emissions' });
export default emissionsStyles;
//# sourceMappingURL=emissions.styles.js.map